export const SalsaImagePlaceholder = (props = {}) => (

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1440 1024" className={props.className}><path fill="#fff" d="M668 499L558.5 615.5h340L777.5 438 706 536l-38-37z" /><circle cx="601" cy="430" r="43" fill="#fff" /></svg>
)

export default SalsaImagePlaceholder